import { SetupPage, TabPermission } from 'src/app/core/interfaces/permissions';
import { Administrative } from 'src/permissions/product-lines/administrative/administrative.setup';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';

const path = 'scopes';
const title = 'PAGE.USERS_ROLES.SCOPES.TITLE';
const parent: SetupPage = Administrative.pages.usersRoles;
const res = [
  'createScope',
  'actions',
  'actions.editScope',
  'actions.deleteScope',
];

export const UsersRolesScopesTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
